import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';
import {
  browserName,
  browserVersion,
  mobileModel,
  mobileVendor,
  osName,
  osVersion,
} from 'react-device-detect';
import LoginController from './controller/LoginController';
import AsyncLocalStorage from './utils/AsyncLocalStorage';
import { isInAppWebView } from './utils/util';

const deviceInfo = require('../package.json');
const sDeviceInfo = `${osVersion}|${osName}|${browserName}|${browserVersion}|${mobileVendor}|${mobileModel}|${deviceInfo.name}|${deviceInfo.version}`;
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};
// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const messaging = () => {
  return getMessaging(firebaseApp);
};

export const requestNotificationPermission = () => {
  LoginController.logToServer({
    permission: 'Requesting User Permission......',
    sDeviceInfo: sDeviceInfo,
  });
  // console.log("Requesting User Permission......");
  try {
    if (!isInAppWebView()) {
      Notification.requestPermission().then((permission) => {
        LoginController.logToServer({ permission: permission, sDeviceInfo: sDeviceInfo });
        // console.log('REACT_APP_FIREBASE_KEY>',process.env.REACT_APP_FIREBASE_KEY);
        if (permission === 'granted') {
          navigator.serviceWorker
            .register(`${process.env.PUBLIC_URL}/firebase-messaging-sw.js`)
            .then(async (registration) => {
              return getToken(messaging(), {
                serviceWorkerRegistration: registration,
                vapidKey: process.env.REACT_APP_FIREBASE_KEY,
              })
                .then(async (currentToken) => {
                  if (currentToken) {
                    AsyncLocalStorage.setItem('hotel-firebaseToken', currentToken.toString());
                    const userInfo = await AsyncLocalStorage.getItem('hotel-userData');
                    const oParams = {
                      firebase_token: currentToken,
                      devices_os_info: sDeviceInfo,
                      app_type: userInfo.app_type,
                    };

                    LoginController.setWebFirebaseToken(oParams);
                  } else {
                    console.log('Failed to generate the app registration token.');
                  }
                })
                .catch((err) => {
                  console.log('An error occurred when requesting to receive the token.', err);
                });
            });
        } else {
          console.log('User Permission Denied.', permission);
        }
      });
    }
  } catch (e) {
    console.error('not supported FCM');
  }
};

/*
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log('onMessageListener vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv', payload);
      resolve(payload);
    });
  });
  */
